const styles = {
    imageStyle: (size: number, radius: string) => ({
        height: size,
        width: size,
        borderRadius: radius,
    }),
    backdrop: (source: string | ArrayBuffer, size: number, radius: string) => ({
        position: 'inherit',
        width: size,
        height: size,
        borderRadius: radius,
        background: `linear-gradient(0deg, rgba(120, 161, 211, 0.5), rgba(120, 161, 211, 0.5)), url(${source})`,
    }),
    initialText: (size: number, radius: string, fontSize: number, bgColor?: string) => ({
        fontFamily: 'Silka_Bold',
        color: '#FFFFFF',
        backgroundColor: bgColor || '#8697AB',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        height: size,
        width: size,
        borderRadius: radius,
        display: 'flex',
        fontWeight: 700,
        fontSize,
        textTransform: 'uppercase',
    }),
    chooseFile: {
        top: '-35px',
        left: 0,
        height: 'calc(100% + 36px)',
        width: 'calc(100% + 5px)',
        outline: 'none',
    },
};

export default styles;
